import { instance } from "./apiClient";

export const encryptedNotesApi = {
  getEncryptedNote: (sourceId) =>
    instance
      .get(`/api/savings_sources/${sourceId}/encrypted_note`)
      .then((res) => res.data),

  verifyPin: (sourceId, pin) =>
    instance
      .post(`/api/savings_sources/${sourceId}/encrypted_note/verify_pin`, {
        pin,
      })
      .then((res) => res.data),

  createEncryptedNote: (sourceId, payload) =>
    instance
      .post(`/api/savings_sources/${sourceId}/encrypted_note`, {
        encrypted_note: payload,
      })
      .then((res) => res.data),

  updateEncryptedNote: (sourceId, payload) =>
    instance
      .put(`/api/savings_sources/${sourceId}/encrypted_note`, {
        encrypted_note: payload,
      })
      .then((res) => res.data),

  deleteEncryptedNote: (sourceId) =>
    instance
      .delete(`/api/savings_sources/${sourceId}/encrypted_note`)
      .then((res) => res.data),
};
